import { deserify } from '@geneo2-web/shared-ui';
import { useAppSelector } from '../reduxStore/reduxHooks';

export const useFilteredLearnSubjects = () => {
  const learnSubjects =
    deserify(useAppSelector((state) => state.auth.userInfo?.learnSubjects)) ||
    [];
  const { sso_subject_ids, is_sso_user } = deserify(
    useAppSelector((state) => state.auth)
  );
  const filteredLearnSubjects =
    is_sso_user && sso_subject_ids && sso_subject_ids.length
      ? learnSubjects.filter((sub) => sso_subject_ids.includes(sub.subjectId))
      : learnSubjects;
  return filteredLearnSubjects;
};
